import { render } from "./Signage.vue?vue&type=template&id=a8c00aea"
import script from "./Signage.vue?vue&type=script&lang=js"
export * from "./Signage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__